module.exports = __webpack_public_path__ + "img/tooltips.83b79f1.png";